module.exports = __webpack_public_path__ + "static/media/app-store-icon.75a24cf1.svg";